import { AppModule } from '@core/enums/app-module.enum';
import { IAppModulePath } from '@models/module/module.model';
import { Routing } from './routing.const';

export const AppModulePath: Array<IAppModulePath> = [
  {
    moduleName: AppModule.Dashboard,
    accessiblePaths: [`${Routing.Dashboard}`],
  },
  {
    moduleName: AppModule.Profile,
    accessiblePaths: [`${Routing.Profile}`],
  },
  {
    moduleName: AppModule.Profile,
    accessiblePaths: [`${Routing.Notification}`],
  },
  {
    moduleName: AppModule.Profile,
    accessiblePaths: [`${Routing.Task}`],
  },
  {
    moduleName: AppModule.Patient,
    accessiblePaths: [`${Routing.Patient}`],
  },
  {
    moduleName: AppModule.VisitNotes,
    accessiblePaths: [`${Routing.VisitNote}`],
  },
  {
    moduleName: AppModule.InvestigationResults,
    accessiblePaths: [`${Routing.InvestigationResult}`],
  },
  {
    moduleName: AppModule.Referrals,
    accessiblePaths: [`${Routing.Referrals}`],
  },
  {
    moduleName: AppModule.Calendar,
    accessiblePaths: [`${Routing.Calendar}`],
  },
  {
    moduleName: AppModule.Invoice,
    accessiblePaths: [`${Routing.Invoice}`],
  },
  {
    moduleName: AppModule.Professionals,
    accessiblePaths: [`${Routing.Professional}`],
  },
  {
    moduleName: AppModule.Messages,
    accessiblePaths: [`${Routing.Message}`],
  },
  {
    moduleName: AppModule.Reports,
    accessiblePaths: [`${Routing.Reports}`],
  },
  {
    moduleName: AppModule.Settings,
    accessiblePaths: [`${Routing.Setting}`],
  },
  {
    moduleName: AppModule.Admin,
    accessiblePaths: [
      `${Routing.Admin}`,
      `${Routing.Admin}/${Routing.User}`,
      `${Routing.Admin}/${Routing.Practitioner}`,
      `${Routing.Admin}/${Routing.UserPermission}`,
      `${Routing.Admin}/${Routing.Location}`,
      `${Routing.Admin}/${Routing.Role}`,
    ],
  },
  {
    moduleName: AppModule.Master,
    accessiblePaths: [
      `${Routing.Master}`,
      `${Routing.Admin}/${Routing.Master}`,
    ],
  },
  {
    moduleName: AppModule.Templates,
    accessiblePaths: [
      `${Routing.Template}`,
      `${Routing.Admin}/${Routing.Template}`,
    ],
  },
];
